import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import {useNavigate} from "react-router-dom";
import LogoPic from "../../Assets/Images/logo.png";
import {FaMobileRetro} from "react-icons/fa6";
import {TbArrowBadgeLeft} from "react-icons/tb";

export default function Login() {
    const navigate = useNavigate();

    const [mobile, setMobile] = React.useState(window.localStorage.getItem("mobile"));
    const [buttonStatus, setButtonStatus] = React.useState(window.localStorage.getItem("mobile") ? "" : "disabled",);
    const [buttonText, setButtonText] = React.useState('دریافت کد ورود');
    const [loading, setLoading] = React.useState('d-none');

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            if(window.localStorage.getItem("needRegistration")){
                navigate('/register');
                return;
            }
            navigate('/home');
        }

    }, [navigate]);

    const onMobileChange = (event) => {
        const mobile = event.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
            setButtonStatus("")
        } else {
            setButtonStatus("disabled")
        }
        setMobile(mobile);
    }

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");

        const request = {
            mobile,
            'processFor' : 'Guardians'
        }
        API.signUp(request)
            .then((response) => {

                    toast.success(response.message);
                    window.localStorage.setItem("mobile", mobile);
                    if(response.data.otp) {
                        window.localStorage.setItem("OTP", response.data.otp);
                    }

                    setTimeout (() => {
                       window.location.replace("/verify");
                    },1500)


            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("دریافت کد ورود");
                setLoading("d-none")
                setButtonStatus('')
            });
    }
    return (
        <React.Fragment>

            <Toast />

            <main>
                <div className="container rtl">

                    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                    <div className="d-flex justify-content-center py-4">
                                        <a href="index.html" className="logo d-flex align-items-center w-auto">
                                            <span className="d-none d-lg-block mx-2 text-small-1">NGKH</span>
                                            <img src={LogoPic} alt="نیروگستران" className="rounded mx-auto " />

                                        </a>
                                    </div>

                                    <div className="card mb-3 py-5 px-2 ">

                                        <div className="card-body">

                                            <div className="pt-4 pb-2">
                                                <h5 className="card-title text-center pb-0 fs-4 mb-3 ">
                                                    ورود به سامانه
                                                </h5>
                                                <p className="text-center text-small-2  text-secondary">
                                                    جهت ورود لطفا شماره همراه خود را وارد کنید
                                                </p>
                                            </div>

                                            <div className="row g-3 needs-validation" >

                                                <div className="col-12 ">
                                                    <label htmlFor="yourUsername" className="form-label text-small-2 text-muted">شماره موبایل</label>
                                                    <div className="input-group has-validation ltr">
                                                        <span className="input-group-text" id="inputGroupPrepend">
                                                            <FaMobileRetro  />
                                                        </span>
                                                        <input type="text" name="username" className="form-control" id="yourUsername"
                                                               value={mobile}
                                                               onChange={onMobileChange}
                                                        />
                                                        <div className="invalid-feedback">
                                                            لطفا شماره تلفن همراه خود را وارد کنید
                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="col-12 mt-5">
                                                    <button
                                                        className="btn btn-warning  text-center text-small-2 text-white  w-100 pt-2 "
                                                        onClick={onButtonClick}
                                                        disabled={buttonStatus}
                                                    >
                                                        {buttonText}
                                                        <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                                                        <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                                               aria-hidden="true">

                            </span>
                                                    </button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>

                    </section>

                </div>
            </main>
        </React.Fragment>
    );
}
